import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { 
  Bars3Icon,
  SparklesIcon,
} from '@heroicons/react/24/outline';
import './Header.css';
import { Category } from '../../features/categories/categoryModels';



interface HeaderDesktopNavProps {
  isMobileMenuOpen: boolean;
  toggleCategoryMenu: () => void;
  categories: Category[];
}

const HeaderDesktopNav: React.FC<HeaderDesktopNavProps> = ({ isMobileMenuOpen, toggleCategoryMenu, categories }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState<string | null>(null);
  const [clickedCategory, setClickedCategory] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    // Trigger entry animation
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleCategoryClick = (categoryId: string) => {
    setClickedCategory(categoryId);
    // Create particle explosion effect
    createParticles();
    setTimeout(() => setClickedCategory(null), 800);
  };

  const createParticles = () => {
    // This creates a visual effect - particles will be handled in CSS
  };

  return (
      <nav className={`navigation ${isMobileMenuOpen ? 'mobile-open' : ''} ${isVisible ? 'nav-visible' : ''}`}>
    
          <div className="nav-content">
            <div className="nav-categories">
              <button 
                className="categories-button epic-button"
                onClick={toggleCategoryMenu}
              >
                <Bars3Icon className="categories-icon" />
                <span>{t('categories.allCategories')}</span>
                <span className="button-glow"></span>
                <span className="button-pulse"></span>
              </button>
            </div>
    
            <div className="nav-links">
              {categories.map((category, index) => {
                const isActive = location.search.includes(category._id);
                return (
                  <Link 
                    key={category._id} 
                    to={`/products?category=${category._id}`} 
                    className={`nav-link epic-nav-link ${isActive ? 'active' : ''} ${clickedCategory === category._id ? 'clicked' : ''}`}
                    style={{ 
                      animationDelay: `${index * 0.1}s`,
                    }}
                    onMouseEnter={() => setHoveredCategory(category._id)}
                    onMouseLeave={() => setHoveredCategory(null)}
                    onClick={() => handleCategoryClick(category._id)}
                  >
                    <span className="link-text">{category.categoryName}</span>
                    <span className="link-underline"></span>
                    <span className="link-glow"></span>
                    {/* {hoveredCategory === category._id && (
                      <span className="hover-particles">
                        <SparklesIcon className="particle" />
                        <SparklesIcon className="particle" />
                        <SparklesIcon className="particle" />
                      </span>
                    )} */}
                    {clickedCategory === category._id && (
                      <span className="click-ripple"></span>
                    )}
                  </Link>
                );
              })}
            </div>


       
        </div>
      </nav>
  );
};

export default HeaderDesktopNav;
